import { render, staticRenderFns } from "./AwaitingApproval.vue?vue&type=template&id=a5cc8710&scoped=true&"
import script from "./AwaitingApproval.vue?vue&type=script&lang=js&"
export * from "./AwaitingApproval.vue?vue&type=script&lang=js&"
import style0 from "./AwaitingApproval.vue?vue&type=style&index=0&id=a5cc8710&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cc8710",
  null
  
)

export default component.exports